// extracted by mini-css-extract-plugin
export default {"sort-button":"SortableColumn_sort-button__+sy85"};